import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../../api/firebase";
import { nbfRawMetarial } from "../../api/restApi";
import { EncodeLevel3Code } from "../../components/Accounts/Account/HelperClass";
import { rawItemsData, setRawItems } from "../../store/reducer/rawItemsSlice";
import { saveLevel3 } from "../../utils/endPoints";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import MaterialTable from "../setting/Tables/MaterialTable";
import { IssueMaterialDialog } from "./components/issueMaterial";

export const RawMaterialStore = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [issueMaterialModal, setIssueMaterialModal] = useState(false);
  const { rawItems } = useAppSelector(rawItemsData);
  const level_3 = useAppSelector((state) => state.accountLevels.level3);
  const dispatch = useAppDispatch();
  const collectionName = "RawMaterial";

  const ItemInfo = async () => {
    let rawItems = await nbfRawMetarial();
    dispatch(setRawItems(rawItems));
  };

  useEffect(() => {
    ItemInfo();
  }, []);
  const IssueMaterial = () => {
    return (
      <Button
        variant="contained"
        color="primary"
         onClick={() => setIssueMaterialModal(true)}
      >
        Issue Material
      </Button>
    );
  };

  const handleCreateNewRow = async (values) => {
    try {
      if (!values || Object.keys(values).length === 0) {
        alert("Please enter valid data");
        return;
      }

      let tempArray = level_3.filter(function (el) {
        return el.fullcode.startsWith("07-003");
      });
      console.log(tempArray);
      const code = EncodeLevel3Code(rawItems.length + 1);
      console.log(code);

      let cust = {
        ...values,
        type: "EXPENSES",
        freeze: "NO",
        // customer_id,
        // description: d.name_english,
        l1code: "07",
        l2code: "07-003",
        code: code,
        fullcode: "07-003-" + code,
        contact: "234",
      };
      values.id = cust.fullcode;
      await setDoc(doc(db, collectionName, values.id), {
        ...values,
        onHand: 0,
        lastPrice: 0,
        lastUpdate: new Date(),
      });
      toast.success("Successfully add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      let res = await saveLevel3(cust.fullcode, cust);

      ItemInfo();
    } catch (error) {
      console.log(error);
      toast.error("Failed to add new item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    try {
      let id = row.getValue("id").toString();
      await updateDoc(doc(db, collectionName, id), values);

      toast.success("Successfully update  item !", {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      ItemInfo();
    } catch (error) {
      // console.log(error);
      toast.error("Failed to  update  item!", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    exitEditingMode(); //required to exit editing mode and close modal
    // }
  };

  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "ID",
      enableColumnOrdering: false,
      enableEditing: false, //disable editing on this column
      enableSorting: false,
      size: 150,
    },
    {
      accessorKey: "name",
      header: "Item Name",
      size: 80,
    },
    {
      accessorKey: "lastPrice",
      header: "Last Price",
      size: 80,
    },

    {
      accessorKey: "onHand",
      header: "OnHand",
      size: 80,
      type: "number",
    },
    {
      accessorKey: "unit",
      header: "Unit",
      size: 40,
      editVariant: "select",
      editSelectOptions: ["kg", "ltr", "packet", "piecs"],
    },
    {
      accessorKey: "unit_size",
      header: "Unit Size",
      size: 80,
      type: "number",
    },
  ]);

  return (
    <>
      <Stack spacing={4} marginX={4} mt={1}>
        <MaterialTable
          setCreateModalOpen={setCreateModalOpen}
          tableData={rawItems}
          handleSaveRowEdits={handleSaveRowEdits}
          columns={columns}
          csvFileName="rawItems"
        >
          <IssueMaterial />
        </MaterialTable>
      </Stack>
      <CreateNewAccountModal
        columns={columns}
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreateNewRow}
      />
      <IssueMaterialDialog
        open={issueMaterialModal}
        onClose={() => setIssueMaterialModal(false)}
      />
    </>
  );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit }) => {
  const initialValues = {};
  const [values, setValues] = useState(initialValues);
  const handleSubmit = async () => {
    onSubmit(values);
    onClose();
  };
  const unitOptions = ["kg", "ltr", "packet", "piecs"];
  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Add Items</DialogTitle>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Stack
            sx={{
              width: "100%",
              minWidth: { xs: "350px", sm: "500px", md: "400px" },
              gap: "1.5rem",
            }}
          >
            <Box>
              <label>Item Name</label>
              <TextField
                type="text"
                sx={{ minWidth: "100%" }}
                value={values.name}
                onChange={(e) => setValues({ ...values, name: e.target.value })}
              />
            </Box>
            <Box>
              <label>Unit Size</label>
              <TextField
                type="number"
                sx={{ minWidth: "100%" }}
                value={values.unit_size}
                onChange={(e) =>
                  setValues({ ...values, unit_size: e.target.value })
                }
              />
            </Box>
            <Box>
              <label>Unit</label>
              <Autocomplete
                disablePortal
                id="combo-box-demo3"
                options={unitOptions}
                sx={{
                  minWidth: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
                renderInput={(params) => <TextField {...params} />}
                value={values.unit}
                onChange={(event, newValue) =>
                  setValues({ ...values, unit: newValue })
                }
              />
            </Box>
            <Box>
              <label>Price</label>
              <TextField
                type="number"
                sx={{ minWidth: "100%" }}
                value={values.price}
                onChange={(e) =>
                  setValues({ ...values, price: e.target.value })
                }
              />
            </Box>
          </Stack>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button color="secondary" onClick={handleSubmit} variant="contained">
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};
